// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m.m--dropdown[data-v-8d06e280],.m__button[data-v-8d06e280]{position:relative}.m__button[data-v-8d06e280]{z-index:1}.m__list[data-v-8d06e280]{position:absolute;left:0;width:100%;padding-top:.5rem;z-index:0;top:100%;transition:opacity .2s ease,transform .2s ease}@media (min-width:960px){.m.m--dropdown[data-v-8d06e280]{position:relative}.m.m--dropdown:not(:hover) .m__list[data-v-8d06e280]{opacity:0;pointer-events:none;transform:translateY(-3rem)}}", ""]);
// Exports
module.exports = exports;
